import React from 'react';
import { Navigate } from 'react-router-dom';

import { RouteErrorBoundary } from '~/contexts/MonitoringProvider';
import { useUserAuthOrThrow } from '~/contexts/UserAuthProvider';
import { AssignmentEditStrategyContainer } from '~/packages/loanProduct/ui/assignmentStrategy/AssignmentEditStrategyContainer';

// Exports
export const Route = () => {
  const { user } = useUserAuthOrThrow();

  // Visibility rules
  if (user.userType !== 'BORROWER') return <Navigate to="/settings" />;

  return (
    <RouteErrorBoundary
      fallback={({ message, showErrorToast }) => {
        showErrorToast(message);
        return <Navigate to="/settings/assignment-strategy" />;
      }}
    >
      <AssignmentEditStrategyContainer readOnly={false} />
    </RouteErrorBoundary>
  );
};
